import { DecisionModalIcon, DecisionModalIconType } from './DecisionModalIcon';
import { CrossIcon } from '../../../../components/svg/CrossIcon';
import {
  iwocapayTelDisplay,
  iwocapayTelLink,
} from '../../../../constants.json';
import { Button } from '../../../components/Button/Button';
import { useModal } from '../../../store/ModalProvider';
import { DecisionErrorTypes } from '../../ApprovalRequirements';
import { useDecision } from '../../DecisionProvider';
import { DIRECTOR_INFO_STEP_ID } from '../../steps/Steps';
import { useNavigateToStep } from '../../steps/useNavigateToStep';

const DECISION_MODAL_ID = 'decisionModal';

export const ErrorModal = () => {
  const { decisionError } = useDecision();
  const { closeModal } = useModal(DECISION_MODAL_ID);
  const goToDirectorInfoStep = useNavigateToStep(DIRECTOR_INFO_STEP_ID);

  if (decisionError === DecisionErrorTypes.DIRECTORS_COMPANY_MISMATCH_ERROR) {
    return (
      <>
        <CrossIcon
          className="absolute right-0 top-[1rem] h-[1.5rem] w-[1.5rem] cursor-pointer fill-structure-40"
          onClick={closeModal}
        />
        <DecisionModalIcon type={DecisionModalIconType.ERROR} />
        <p className="mb-l text-center text-xl font-bold text-structure-40">
          Something doesn't look right
        </p>
        <div className="mb-l text-center text-m font-reg text-structure-40">
          There is an error matching your details.
          <br />
          Please enter your full legal name
        </div>
        <Button
          className="mt-[20px]"
          onClick={() => {
            goToDirectorInfoStep();
            closeModal();
          }}
        >
          Edit details
        </Button>
      </>
    );
  }

  if (decisionError === DecisionErrorTypes.INCOMPLETE_CREDIT_CHECK_ERROR) {
    return (
      <>
        <CrossIcon
          className="absolute right-0 top-[1rem] h-[1.5rem] w-[1.5rem] cursor-pointer fill-structure-40"
          onClick={closeModal}
        />
        <DecisionModalIcon type={DecisionModalIconType.ERROR} />
        <p className="mb-l text-center text-xl font-bold text-structure-40">
          Something doesn't look right
        </p>
        <div className="mb-l text-center text-m font-reg text-structure-40">
          Please check you've:
        </div>
        <ul className="mb-l ml-s mt-r pl-xl text-m text-structure-40">
          <li>used your full legal name &mdash; not a shortened version</li>
          <li>used your personal address &mdash; not your business address</li>
          <li>
            if you've moved in the last few months, enter your previous address
          </li>
        </ul>
        <Button
          className="mt-[20px]"
          onClick={() => {
            goToDirectorInfoStep();
            closeModal();
          }}
        >
          Edit details
        </Button>
        <div className="pt-l text-center text-s text-structure-60">
          Need some help? Give us a call on{' '}
          <a href={iwocapayTelLink} className="text-primary-40">
            {iwocapayTelDisplay}
          </a>
        </div>
      </>
    );
  }

  return (
    <>
      <CrossIcon
        className="absolute right-0 top-[1rem] h-[1.5rem] w-[1.5rem] cursor-pointer fill-structure-40"
        onClick={closeModal}
      />
      <DecisionModalIcon type={DecisionModalIconType.UNKNOWN} />

      <p className="mb-l text-center text-xl font-bold text-structure-40">
        Something went wrong...
      </p>
      <div className="mb-l text-center text-m font-reg text-structure-40">
        <>
          <p>Please check your details.</p>
          <p>
            Need help? If so please give us a call{' '}
            <a href={iwocapayTelLink}>{iwocapayTelDisplay}</a>.
          </p>
          <Button
            className="mt-[20px]"
            onClick={() => {
              closeModal();
            }}
          >
            Edit details
          </Button>
        </>
      </div>
    </>
  );
};
